// The Google Forms import switch (GOOGLE_FORMS_IMPORT): why imports are not offered.
export const googleFormsImport = {
    readonly: {
        title: 'GOOGLE_FORMS_IMPORT.READONLY.TITLE',
        description: 'GOOGLE_FORMS_IMPORT.READONLY.DESCRIPTION',
        createPage: 'GOOGLE_FORMS_IMPORT.READONLY.CREATE_PAGE'
    },
    off: {
        title: 'GOOGLE_FORMS_IMPORT.OFF.TITLE',
        description: 'GOOGLE_FORMS_IMPORT.OFF.DESCRIPTION',
        sheets: 'GOOGLE_FORMS_IMPORT.OFF.SHEETS'
    }
};
